import script from "./picture-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./picture-list.vue?vue&type=script&lang=ts&setup=true"

import "./picture-list.vue?vue&type=style&index=0&id=f4e347ec&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4e347ec"]])

export default __exports__